import React from 'react'
import AttemptBox from '../components/AttemptBox.js'
import { firestore } from '../Firebase';
import AppBar from '../components/AppBar.js';
import thumbsup from '../assets/thumbs-up.png';
import star from '../assets/star.png';

function GameResults(props) {
    var id = ""
    var data = []
    var numberOfCorrects = 0 // need to compute percentage
    var streak = 0
    var max = 0

    const fields = [
        'smt',
        'pnc',
        'krb',
        'jfg',
        'hdw',
        'vly'
    ];
    var field = fields[props.level - 1]
    let attempts = []
    var performance = 0;

    for (let i = 0; i < props.responses.length; i++) {
        attempts[i] = <AttemptBox bool={props.responses[i][1]} letter={props.responses[i][0].toUpperCase()} />;
    }

    for (let i = 0; i < props.responses.length; i++) {
        if (props.responses[i][1] === 'correct') {
            streak += 1
            if (streak > max) {
                max = streak
            }
            numberOfCorrects += 1
        }
        else {
            streak = 0
        }
    }

    if (numberOfCorrects / props.responses.length >= 0.75) {
        performance = 3
    } else if (numberOfCorrects / props.responses.length < 0.75 && numberOfCorrects / props.responses.length >= 0.3) {
        performance = 2
    } else if (numberOfCorrects / props.responses.length < 0.3) {
        performance = 1
    }

    async function sendData() {
        const matches = await firestore.collection('accounts').where('username', '==', props.identification.username).where('password', '==', props.identification.password).get()
        matches.docs.forEach((doc) => {
            id = doc.id
            data = doc.data()[field]
        })
        firestore.collection('accounts').doc(id).update({
            [field]: data.concat(props.responses.flat()),
            last_8: props.responses.flat()
        })
    }

    sendData()

    switch (performance) {
        case 1:
            return (
                <div className='column'>
                    <AppBar backTo='Level Select' displayText='Level Select' />
                    <img style={{ width: 200, height: 200, marginTop: 50 }} src={thumbsup} alt='Well done' />
                    <img style={{ width: 100, height: 100, marginTop: 25 }} src={star} alt='Star' />
                    <b className='titleText' style={{ fontSize: 40, marginTop: 50 }}>You got {numberOfCorrects} correct out of {attempts.length}!</b>
                    <b className='titleText' style={{ fontSize: 40 }}>Don't worry, you can try again!</b>
                    <b className='titleText' style={{ fontSize: 30 }}>{Math.round(numberOfCorrects / attempts.length * 100)}%</b>
                    <b className='titleText' style={{ fontSize: 30 }}>Longest streak: {max}</b>
                    <div className='tenAttemptRow'>
                        {attempts}
                    </div>
                </div>
            )
        case 2:
            return (
                <div className='column'>
                    <AppBar backTo='Level Select' displayText='Level Select' />
                    <img style={{ width: 200, height: 200, marginTop: 50 }} src={thumbsup} alt='Well done' />
                    <div className='row' style={{ marginTop: 25 }}>
                        <img style={{ width: 100, height: 100 }} src={star} alt='Star' />
                        <img style={{ width: 100, height: 100 }} src={star} alt='Star' />
                    </div>
                    <b className='titleText' style={{ fontSize: 40, marginTop: 50 }}>Good job! You got {numberOfCorrects} correct out of {attempts.length}!</b>
                    <b className='titleText' style={{ fontSize: 40 }}>Try again for a better score!</b>
                    <b className='titleText' style={{ fontSize: 30 }}>{Math.round(numberOfCorrects / attempts.length * 100)}%</b>
                    <b className='titleText' style={{ fontSize: 30 }}>Longest streak: {max}</b>
                    <div className='tenAttemptRow'>
                        {attempts}
                    </div>
                </div>
            )
        case 3:
            return (
                <div className='column'>
                    <AppBar backTo='Level Select' displayText='Level Select' />
                    <img style={{ width: 200, height: 200, marginTop: 50 }} src={thumbsup} alt='Well done' />
                    <div className='row' style={{ marginTop: 25 }}>
                        <img style={{ width: 100, height: 100 }} src={star} alt='Star' />
                        <img style={{ width: 100, height: 100 }} src={star} alt='Star' />
                        <img style={{ width: 100, height: 100 }} src={star} alt='Star' />
                    </div>
                    <b className='titleText' style={{ fontSize: 40, marginTop: 50 }}>Well done! You got {numberOfCorrects} correct out of {attempts.length}!</b>
                    <b className='titleText' style={{ fontSize: 40 }}>You nailed it. Try the next level!</b>
                    <b className='titleText' style={{ fontSize: 30 }}>{Math.round(numberOfCorrects / attempts.length * 100)}%</b>
                    <b className='titleText' style={{ fontSize: 30 }}>Longest streak: {max}</b>
                    <div className='tenAttemptRow'>
                        {attempts}
                    </div>
                </div>
            )
        default:
    }
}

export default GameResults;